export default "__VITE_PUBLIC_ASSET__d307aded__"